export const deviceType = {
  all: "All",
  ap: "AP",
  switch: "SWITCH",
  gateway: "GATEWAY",
};

export const deviceConfig = {
  UIDLength: 12,
  registered: "STATE_REGISTERED",
  unregistered: "STATE_UNREGISTERED",
  lockStC: {
    'United States': 'us',
    'Japan': 'jp',
    'South Korea': 'kr',
  },
  licenseState: {
    ACTIVATED: "ACTIVATED",
    EXPIRE_SOON: "EXPIRE_SOON",
    NOT_ACTIVATED: "NOT_ACTIVATED",
    EXHAUSTED: "EXHAUSTED",
    NO_LICENSE: "NO_LICENSE",
    SUSPENDED: "SUSPENDED",
  },
};

export const deviceStates = {
  UIDLength: 12,
  registered: "STATE_REGISTERED",
  unregistered: "STATE_UNREGISTERED",
  online: true,
  offline: true,
  configuration: {
    upToDate: "Up to date",
    inProgress: "In progress",
    updateFailed: "Update failed",
  },
  connectivity: {
    online: "device-online",
    offline: "device-offline",
  }
};

export const statusList = [
  { value: "All", statusType: "All", label: "b1c94ca2fb" },
  { value: 1, statusType: "online", label: "54f664c70c" },
  { value: 0, statusType: "offline", label: "8d9da4bc0e" },
  { value: -1, statusType: "dormant", label: "96542608b4" },
];

export const searchItemUseSelect = [
  "onlineStatus",
  "productCategory",
  "modelName",
  "used",
  "expirationTimeStamp",
];
